module.exports = __webpack_public_path__ + "img/Frame4300.5001fafe.jpg";